export default __webpack_public_path__ + "static/media/hadUk.9b738130.png";